import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full py-28 md:py-36 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20lifestyle%20flat%20lay%20with%20colorful%20fashion%20accessories%20shopping%20bags%20and%20trendy%20items%20on%20warm%20terracotta%20and%20sand%20colored%20surface%2C%20golden%20hour%20natural%20lighting%20casting%20dramatic%20long%20shadows%2C%20rich%20bold%20aesthetic%2C%20editorial%20photography%20with%20dynamic%20composition%2C%20Mediterranean%20inspired%20warm%20tones%2C%20celebration%20of%20style%20and%20discovery&width=1920&height=800&seq=cta-bg-v2&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-foreground-900/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto text-center px-4 md:px-6">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-5 tracking-wide uppercase">
          {t('cta.title')}
        </h2>
        <p className="text-background-100/90 text-base md:text-lg mb-10 max-w-2xl mx-auto">
          {t('cta.subtitle')}
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 bg-foreground-900 text-background-50 text-base font-semibold px-8 py-4 rounded-full hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
        >
          <span className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center">
            <i className="ri-shopping-bag-line text-background-50"></i>
          </span>
          {t('cta.button')}
          <i className="ri-arrow-right-up-line text-lg"></i>
        </a>
      </div>
    </section>
  );
}